import React from 'react';
import styles from './AdvtFullSize.module.css';
import { useGetParams } from '../../hooks/useGetParams';
import classNames from 'classnames';
import { motion } from 'framer-motion';

const AdvtFullSize = React.memo(({ className, currentState, advtInfo }) => {
  const { paddingQR, sizeQR, titleFontSize } = useGetParams();

  const { label, qrCode1, qrCode2 } = advtInfo;

  return (
    <div
      className={classNames(styles.container, className, {
        [styles.large]: currentState === 'S2',
      })}
    >
      {currentState === 'S2' && (
        <motion.div
          key="title"
          initial={{ transform: 'translateY(2000px)' }}
          animate={{ transform: 'translateY(0)' }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <h1
            className={styles.title}
            style={{ fontSize: `${titleFontSize}rem` }}
          >
            {label}
          </h1>
        </motion.div>
      )}
      <div
        className={classNames(styles.qrCodes, {
          [styles.hidden]: currentState !== 'S2',
        })}
      >
        {qrCode1 && (
          <motion.div
            key={currentState + 'qr1'}
            initial={{ transform: 'scale(0)' }}
            animate={{ transform: 'scale(1)' }}
            transition={{ duration: 0.5, delay: 1 }}
            className={classNames(styles.rainbow, styles.rainbow1)}
            style={{
              width: `calc(${sizeQR}rem + 0.5rem)`,
              height: `calc(${sizeQR}rem + 1rem)`,
              padding: `0.5rem`,
            }}
          >
            <div
              style={{
                padding: `${paddingQR}rem`,
                width: `${sizeQR}rem`,
                height: `${sizeQR}rem`,
              }}
            >
              <img src={qrCode1} alt="" />
            </div>
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            key={currentState + 'qr2'}
            initial={{ transform: 'scale(0)' }}
            animate={{ transform: 'scale(1)' }}
            transition={{ duration: 0.5, delay: 1.2 }}
            className={classNames(styles.rainbow, styles.rainbow2)}
            style={{
              width: `calc(${sizeQR}rem + 0.5rem)`,
              height: `calc(${sizeQR}rem + 1rem)`,
              padding: `0.5rem`,
            }}
          >
            <div
              style={{
                padding: `${paddingQR}rem`,
                width: `${sizeQR}rem`,
                height: `${sizeQR}rem`,
              }}
            >
              <img src={qrCode2} alt="" />
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
});

export default AdvtFullSize;
